const LOCAL_API_BASE = 'http://localhost:8001';

export function getApiBase() {
  const envBase = (process.env.REACT_APP_BACKEND_URL || '').trim();
  if (envBase) {
    return envBase.replace(/\/$/, '');
  }

  if (typeof window !== 'undefined') {
    const { origin, hostname } = window.location;
    const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';
    return (isLocalHost ? LOCAL_API_BASE : origin).replace(/\/$/, '');
  }

  return LOCAL_API_BASE;
}
